import React, { useEffect, useCallback } from "react";
import SubmitStepButton from "./SubmitStepButton";
import Translation from "../../../../shared/Translation";
import WithCurrencyConfig from "../../../config/WithCurrencyConfig";
import { getJSFormattedCurrency } from "@checkout-h/currency";
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderTotal } from '@checkout/selectors/cart';
import { getMainEvent } from '@checkout/selectors/event';
import { isDynamicListing } from '@checkout/selectors/dynamic-listing';
import { goToPrevStep, setCheckoutOverlay } from '@checkout/actions/ui';
import { navigate } from '@checkout-h/navigationService';

export interface StepActionProps {
  firstStep: boolean;
  lastStep: boolean;
  disabled?: boolean;
  orderTotal: number;
  onBack: () => void;
  terminalId?: any;
  currencyConfig?: unknown; // type this better if you have a CurrencyConfig type
}

const escapeValidators = [
  // @ts-ignore
  () => document.activeElement.name === "date_question",
  // @ts-ignore
  () => document.activeElement.className.startsWith("rdp")
]

const canUseEscapeKey = () => {
  if (escapeValidators.some(fn => fn())) {
    return false;
  }
  return true;
}

const StepAction: React.FC<StepActionProps> = ({
                                                 firstStep,
                                                 lastStep,
                                                 disabled,
                                                 orderTotal,
                                                 onBack,
                                                 terminalId,
                                                 currencyConfig,
                                               }) => {
  const escFunction = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape"  && canUseEscapeKey()) {
        onBack();
      }
    },
    [onBack]
  );

  useEffect(() => {
    document.addEventListener("keydown", escFunction);
    return () => {
      document.removeEventListener("keydown", escFunction);
    };
  }, [escFunction]);

  const getFormattedTotal = (amount: number) => {
    return currencyConfig ? getJSFormattedCurrency(amount, currencyConfig) : "";
  };

  return (
    <div>
      <footer className="checkout-form__footer">
        <div className="checkout-form__buttons">
          {!terminalId && <SubmitStepButton disabled={disabled} />}
        </div>
      </footer>
    </div>
  );
};

export default WithCurrencyConfig(StepAction);
